import { FC, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Loading } from '../../../components/Loading/Loading'
import { DELETE, GET, POST, PUT } from '../../../services/api'
import { i18n } from '../../../translate/i18n'
import Swal from 'sweetalert2'

import styles from './config.module.css'
import { ModalWrapper } from '../../../components/Modals/General/ModalWrapper/ModalWrapper'
import useModals from '../../../hooks/useModals'
import { Input } from '../../../components/Input/Input'
import useAuth from '../../../hooks/useAuth'
import { ModalDelete } from '../../../components/Modals/General/ModalDelete/ModalDelete'
import { BreadCrumbs } from '../../../components/BreadCrumbs/breadCrumbrs'
import { Button } from '../../../components/Button/Button'
import { hideCornerCharacters } from '../../../utils/formater'
import { getPluginSpaceData } from '../../../utils/pluginSpaceUtils'
import usePluginsSpace from '../../../hooks/usePluginSpace'

type PluginconfigType = {
  id: number
  name: string
  content: any
  plugintemplateId: number
  plugintypeId: number
}

type PaymentType = {
  id: number
  name: string
  image: string | null
  parameters: string
  plugintypeId: number
  pluginconfig: PluginconfigType
  ableCredit: boolean | null
  ableDebit: boolean | null
  ableAlimentation: boolean | null
  ablePix: boolean | null
}

type ConfigInputsType = {
  name: string
  value: string
  originalName: string
}

type InstallmentType = {
  installment: number
  code: number
}

type PlansType = {
  id: number
  gateway: string
  brand: string
  brandItem: BrandResponseType | null
  type: string
  code: string
  minimumValue: number
  installments?: InstallmentType[]
  ableDiscount: boolean
  typeDiscount?: 'monetary' | 'percentage'
  discountValue?: number
}

type PlansResponseType = {
  id: number
  codePlan: number
  installment: number
}

type IntegrationResponseType = {
  id: number
  brand: string
  cardOperator: number
  codePay: string
  nameGateway: string
  paymentPlans: PlansResponseType[]
  typePay: string
  pluginconfigId: number
  brandItem?: BrandResponseType
  minimumValueInstallment: string
  ableDiscount: boolean
  typeDiscount?: 'monetary' | 'percentage'
  discountValue?: number
}

type SelectType = {
  value: number
  select: string
}

type BrandResponseType = {
  id: number
  tband: number
  operator: string
  img: string | null
}

type PlanSendType = {
  installment: number
  rate: string
  paymentTerm: string
  codePlan: number
}

type IntegrationSendType = {
  nameGateway: string
  brand: string
  cardOperator: number
  typePay: string
  codePay: string
  pluginspaceId: number | null
  pluginconfigId: number
  plugintemplateId: number
  paymentPlan: PlanSendType[]
  hash: string
  minimumValueInstallment: number
  ableDiscount: boolean
  typeDiscount?: 'monetary' | 'percentage' | null
  discountValue?: number
}

const PaymentConfigContent: FC = () => {
  const { id } = useParams()
  const { pluginSpaceFeatures } = usePluginsSpace()
  const { loginInfo } = useAuth()
  const { showWrapperModal, closeWrapperModal, showDeleteModal } = useModals()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [payment, setPayment] = useState<PaymentType | null>()
  const [configValues, setConfigValues] = useState<ConfigInputsType[]>([])
  const [plans, setPlans] = useState<Array<PlansType>>([])
  const [action, setAction] = useState<'create' | 'edit'>('create')

  const [typeCard, setTypeCard] = useState<'credit' | 'debit' | 'pix' | 'money' | 'others'>(
    'credit'
  )
  const [brandId, setBrandId] = useState(0)
  const [brandName, setBrandName] = useState('')
  const [brandImg, setBrandImg] = useState('')
  const [codeErpIntegration, setCodeErpIntegration] = useState('')
  const [brands, setBrands] = useState<Array<SelectType>>([])
  const [installments, setInstallments] = useState(1)
  const [minimumValue, setMinimumValue] = useState(0)
  const [listInstallments, setListInstallments] = useState<InstallmentType[]>([
    { code: 1, installment: 1 },
  ])
  const [editId, setEditId] = useState(0)
  const [hasIntegration, setHasIntegration] = useState(false)
  //variavel utilizada para nomear o meio de pagamento para o tipo 'others'
  const [brandNameOthers, setBrandNameOthers] = useState('')
  // variavel utilizada para habilitar desconto e valores
  const [discountAble, setDiscountAble] = useState<boolean>(false)
  const [discountType, setDiscountType] = useState<'percentage' | 'monetary' | null>()
  const [discountValue, setDiscountValue] = useState<number>()

  const hasMotorDiscount = pluginSpaceFeatures.some(feature => feature.feature.name === 'Motor de Promoção')

  const verifyIntegration = async () => {
    try {
      const res = await GET(`/pluginconfig`)
      const totvsIntegration = res.data.filter(
        (pluginconfig: PluginconfigType) =>
          pluginconfig.plugintemplateId === 23 ||
          pluginconfig.plugintemplateId === 15 ||
          pluginconfig.plugintemplateId === 45 ||
          pluginconfig.plugintemplateId === 48 ||
          pluginconfig.plugintemplateId === 104
      )

      if (totvsIntegration && totvsIntegration.length > 0) setHasIntegration(true)
      else setHasIntegration(false)
    } catch (e) {
      setHasIntegration(false)
    }
  }

  // Ajuste na hash
  const getPaymentPlans = async (pluginconfigId: number) => {
    try {
      const resPluginspace = await getPluginSpaceData()
      if (resPluginspace && resPluginspace.hash) {
        const resIntegration = await POST(`orders/card-payment-get`, {
          hash: resPluginspace.hash,
        })
        if (
          resIntegration.data &&
          resIntegration.data.data &&
          resIntegration.data.data.length > 0
        ) {
          const newListPlans: PlansType[] = resIntegration.data.data
            .filter(
              (integration: IntegrationResponseType) =>
                integration.pluginconfigId === pluginconfigId
            )
            .map((integrationResponse: IntegrationResponseType) => ({
              id: integrationResponse.id,
              gateway: integrationResponse.nameGateway,
              brand: integrationResponse.brand,
              brandItem: integrationResponse.brandItem ? integrationResponse.brandItem : null,
              type: integrationResponse.typePay,
              code: integrationResponse.codePay,
              installments: integrationResponse.paymentPlans.map((planResponse) => ({
                installment: planResponse.installment,
                code: planResponse.codePlan,
              })),
              minimumValue: parseFloat(integrationResponse.minimumValueInstallment),
              ableDiscount: integrationResponse.ableDiscount,
              typeDiscount: integrationResponse.typeDiscount,
              discountValue: integrationResponse.discountValue
                ? parseFloat(integrationResponse.discountValue?.toString())
                : 0,
            }))
          setPlans(newListPlans)
          return
        }
        setPlans([])
      }
    } catch (e) {
      console.log(e)
      setPlans([])
    }
  }

  const getBrands = async () => {
    try {
      setLoading(true)
      const brandRes = await GET(`/operator`)
      const newBrands: SelectType[] = brandRes.data.map((brand: BrandResponseType) => {
        return {
          value: brand.tband,
          select: brand.operator,
        }
      })
      setBrands([{ select: 'Selecione uma bandeira', value: 0 }, ...newBrands])
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const getPlugintemplate = async () => {
    try {
      const res = await GET(`/plugintemplate/payments/${id}`)
      if (res.success && res.data && res.data.length > 0) {
        await getPaymentPlans(res.data[0].pluginconfig.id)
        await getBrands()
        await verifyIntegration()
        setPayment(res.data[0])
        const paymentConfig = JSON.parse(res.data[0].parameters).config
        setConfigValues(
          Object.entries(res.data[0].pluginconfig.content)
            .filter((item) => item[0] && !item[0].includes('able') && item[0] !== 'pix')
            .map((item: any[]) => {
              return {
                originalName: item[0],
                name: paymentConfig[item[0]],
                value: item[1],
              }
            })
        )
        return
      }
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: 'Falha ao recuperar meio de pagamento.',
      })
      return
    } catch (e) {
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: 'Falha ao recuperar meio de pagamento.',
      })
    }
  }

  const selectInstallments = (value: number) => {
    setInstallments(value)
    let newList: InstallmentType[] = []
    for (let i = 0; i < value; i++) {
      newList.push({ code: i + 1, installment: i + 1 })
    }
    setListInstallments(newList)
  }

  /*Funcoa utilizada para abrir modal de Editar Pagamento */
  const changePaymentPlan = (plan: PlansType) => {
    if (
      plan.type.toLowerCase() === 'credit' ||
      plan.type.toLowerCase() === 'debit' ||
      plan.type.toLowerCase() === 'pix' ||
      plan.type.toLowerCase() === 'money' ||
      plan.type.toLowerCase() === 'others'
    ) {
      const type: any = plan.type.toLowerCase()
      setTypeCard(type)
    } else {
      setTypeCard('credit')
    }
    setCodeErpIntegration(plan.code)

    let brand = brands.find((brd) => brd.select === plan.brand)
    setBrandId(brand ? brand.value : 0)
    setBrandName(brand ? brand.select : '')
    if (plan.brandItem && plan.brandItem.img) {
      setBrandImg(plan.brandItem.img)
    } else {
      setBrandImg('')
    }

    if (plan.installments && plan.installments.length > 0) {
      setListInstallments(plan.installments)
      setInstallments(plan.installments.length)
      setMinimumValue(plan.minimumValue)
    } else {
      setListInstallments([{ code: 1, installment: 1 }])
      setInstallments(1)
      setMinimumValue(plan.minimumValue)
    }

    if (plan.type.toLowerCase() === 'others' && plan.brand) {
      setBrandNameOthers(plan.brand)
    }
    /* Novos campos para o desconto */
    setDiscountAble(plan.ableDiscount)
    setDiscountType(plan.typeDiscount)
    setDiscountValue(plan.discountValue ? parseFloat(plan.discountValue.toString()) : 0)
  }

  const verifySamePayment = (brandValue: number) => {
    const findedPlan = plans.find(
      (plan) =>
        plan.brandItem &&
        plan.brandItem.id === brandValue &&
        plan.type === typeCard.charAt(0).toUpperCase() + typeCard.slice(1)
    )
    return findedPlan ? true : false
  }

  const createPaymentMethod = async () => {
    try {
      if ((typeCard === 'credit' || typeCard === 'debit') && !brandId) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Verifique se as informações estão completas para cadastrar',
        })
        return
      } else {
        let brand = ''
        let brandValue = brandId

        if (typeCard === 'others' && !brandNameOthers) {
          setLoading(false)
          Swal.fire({
            icon: 'warning',
            title: 'Atenção!',
            text: 'Nome não informado para pagamento!',
          })

          return
        }

        if (typeCard === 'pix') {
          const brandItem = brands.find((brd) => brd.select === 'Pix')
          brand = 'Pix'
          brandValue = brandItem ? brandItem.value : brandId
        } else if (typeCard === 'money') {
          const brandItem = brands.find((brd) => brd.select === 'Dinheiro')
          brand = 'Dinheiro'
          brandValue = brandItem ? brandItem.value : brandId
        } else if (typeCard === 'others') {
          brand = brandNameOthers
        } else {
          const brandItem = brands.find((brd) => brd.value === brandId)
          brand = brandItem ? brandItem.select : ''
        }

        if (verifySamePayment(brandValue)) {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção!',
            text:
              brand === 'Pix' || brand === 'Dinheiro'
                ? `Você já possui uma forma de pagamento com ${brand}`
                : `Voê já possui uma forma de pagamento com ${brand} - Cartão de ${typeCard === 'credit' ? 'crédito' : 'débito'
                }`,
          })
          return
        }

        // eslint-disable-next-line eqeqeq
        if (discountAble && ((discountValue != undefined && discountValue <= 0) || !discountType)) {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção!',
            text: 'Valor de desconto ou Tipo de desconto inválido!',
          })
          return
        }

        setLoading(true)
        const resPluginspace = await getPluginSpaceData()

        if (resPluginspace && resPluginspace.hash) {
          const dataIntegrationSend: IntegrationSendType[] = [
            {
              nameGateway: payment ? payment.pluginconfig.name : '',
              brand: brand,
              cardOperator: brandValue,
              typePay: typeCard.charAt(0).toUpperCase() + typeCard.slice(1),
              codePay: codeErpIntegration
                ? codeErpIntegration
                : typeCard === 'others'
                  ? brandNameOthers.toLowerCase()
                  : brand.toLowerCase(),
              pluginspaceId: loginInfo.pluginspaceId,
              pluginconfigId: payment ? payment.pluginconfig.id : 0,
              plugintemplateId: payment ? payment.pluginconfig.plugintemplateId : 0,
              paymentPlan: listInstallments.map((plan) => ({
                installment: plan.installment,
                rate: '0',
                paymentTerm: '0',
                codePlan: plan.code ? plan.code : plan.installment,
              })),
              minimumValueInstallment: minimumValue,
              hash: resPluginspace.hash ?? resPluginspace.data[0].hash,
              discountValue: discountValue ? discountValue : 0,
              ableDiscount: discountAble,
              typeDiscount: discountType,
            },
          ]
          const result = await POST(`orders/card-payment`, { data: dataIntegrationSend })
          setLoading(false)
          if (result.success === true) {
            Swal.fire({
              icon: 'success',
              title: 'Integrações cadastradas',
              text: 'Cadastro realizado com sucesso!',
            }).then(async () => {
              clearFields()
              closeWrapperModal()
              await init()
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              text: 'Erro ao cadastrar forma de pagamento!',
            })
          }
        } else {
          setLoading(false)
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao cadastrar forma de pagamento!',
          })
          return
        }
      }
    } catch (e: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e ? e : 'Erro ao cadastrar forma de pagamento!',
      })
    }
  }

  const editPaymentMethod = async () => {
    try {
      setLoading(true)

      const resPluginspace = await getPluginSpaceData()
      let brand = ''
      let brandValue = brandId

      if (typeCard === 'others' && !brandNameOthers) {
        setLoading(false)
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Nome não informado para pagamento!',
        })

        return
      }

      if (typeCard === 'pix') {
        const brandItem = brands.find((brd) => brd.select === 'Pix')
        brand = 'Pix'
        brandValue = brandItem ? brandItem.value : brandId
      } else if (typeCard === 'money') {
        const brandItem = brands.find((brd) => brd.select === 'Dinheiro')
        brand = 'Dinheiro'
        brandValue = brandItem ? brandItem.value : brandId
      } else if (typeCard === 'others') {
        brand = brandNameOthers
      } else {
        const brandItem = brands.find((brd) => brd.value === brandId)
        brand = brandItem ? brandItem.select : ''
      }

      // eslint-disable-next-line eqeqeq
      if (discountAble && ((discountValue != undefined && discountValue <= 0) || !discountType)) {
        setLoading(false)
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Valor de desconto ou Tipo de desconto inválido!',
        })
        return
      }

      if (resPluginspace.data && resPluginspace.data[0] && resPluginspace.data[0].hash) {
        const dataIntegrationSend: IntegrationSendType[] = [
          {
            nameGateway: payment ? payment.pluginconfig.name : '',
            brand: brand,
            cardOperator: brandValue,
            typePay: typeCard.charAt(0).toUpperCase() + typeCard.slice(1),
            codePay: codeErpIntegration
              ? codeErpIntegration
              : typeCard === 'others'
                ? brandNameOthers.toLowerCase()
                : brand.toLowerCase(),
            pluginspaceId: loginInfo.pluginspaceId,
            pluginconfigId: payment ? payment.pluginconfig.id : 0,
            plugintemplateId: payment ? payment.pluginconfig.plugintemplateId : 0,
            paymentPlan: listInstallments.map((plan) => ({
              installment: plan.installment,
              rate: '0',
              paymentTerm: '0',
              codePlan: plan.code ? plan.code : plan.installment,
            })),
            minimumValueInstallment: minimumValue,
            hash: resPluginspace.data[0].hash,
            discountValue: discountValue ? discountValue : 0,
            ableDiscount: discountAble,
            typeDiscount: discountAble ? discountType : undefined,
          },
        ]
        await PUT(`orders/card-payment/${editId}`, {
          hash: resPluginspace.data[0].hash,
          data: { deleted: new Date() },
        })
        const result = await POST(`orders/card-payment`, { data: dataIntegrationSend })
        setLoading(false)
        if (result.success === true) {
          Swal.fire({
            icon: 'success',
            title: 'Integrações atualizadas',
            text: 'Edição realizada com sucesso!',
          }).then(async () => {
            clearFields()
            closeWrapperModal()
            await init()
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao editar forma de pagamento!',
          })
        }
      } else {
        setLoading(false)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao editar forma de pagamento!',
        })
        return
      }
    } catch (e: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e ? e : 'Erro ao editar forma de pagamento!',
      })
    }
  }

  const deletePaymentConfig = async () => {
    try {
      Swal.fire({
        title: 'Você tem certeza?',
        text: 'A configuração de pagamento será deletada.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, deletar!',
        cancelButtonText: 'Não, cancelar!',
      }).then(async (resultSwal) => {
        if (resultSwal.isConfirmed) {
          setLoading(true)
          const result = await DELETE(`pluginconfig/${payment?.pluginconfig.id}`)
          setLoading(false)
          if (result.success === true) {
            Swal.fire({
              icon: 'success',
              title: 'Sucesso!',
              text: 'Configuração de pagamento deletada com sucesso.',
            }).then(async () => {
              navigate(`/configuracoes/pagamentos`)
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              text: 'Erro ao excluir configuração de pagamento!',
            })
          }
        }
      })
    } catch (e: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e ? e : 'Erro ao excluir configuração de pagamento!',
      })
    }
  }

  const deletePayment = async () => {
    try {
      setLoading(true)
      const resPluginspace = await getPluginSpaceData()
      const result = await PUT(`orders/card-payment/${editId}`, {
        hash: resPluginspace.hash,
        data: { deleted: new Date() },
      })
      setLoading(false)
      if (result.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Meio de pagamento deletado com sucesso.',
        }).then(async () => {
          clearFields()
          closeWrapperModal()
          await init()
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao excluir forma de pagamento!',
        })
      }
    } catch (e: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e ? e : 'Erro ao excluir forma de pagamento!',
      })
    }
  }

  const clearFields = () => {
    setTypeCard('credit')
    setBrandId(0)
    setBrandName('')
    setBrandImg('')
    setCodeErpIntegration('')
    setInstallments(1)
    setMinimumValue(0)
    setBrandNameOthers('')
    setListInstallments([{ code: 1, installment: 1 }])
    setDiscountAble(false)
    setDiscountType(null)
    setDiscountValue(0)
  }

  const findType = (type: string) => {
    switch (type) {
      case 'Credit':
        return i18n.t(`payment.card`)
      case 'Debit':
        return i18n.t(`payment.debit`)
      case 'Others':
        return i18n.t(`payment.others`)
      default:
        return ''
    }
  }

  const verifySecurity = (item: string) => {
    switch (item) {
      case 'pv':
        return 4
      case 'token':
        return 4
      case 'client_secret':
        return 4
      case 'MerchantKey':
        return 4
      case 'MerchantId':
        return 4
      case 'merchant_key':
        return 4
      case 'merchant_id':
        return 4
      default:
        return 0
    }
  }

  const init = async () => {
    setLoading(true)
    await getPlugintemplate()
    setLoading(false)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
          <div className='row g-5 gx-xxl-12'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12'>
              <div className='card-header py-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`payment.methods`)}</span>
                  <BreadCrumbs />
                </h3>
              </div>
              {payment && (
                <div className='card-body d-flex flex-column gap-5'>
                  <div className={styles.goBack}>
                    {payment.image && <img src={payment.image} alt={payment.name} />}
                  </div>
                  <div className={styles.configItem}>
                    <div className={styles.configHead}>
                      <h2>{i18n.t(`payment.basic_settings`)}</h2>
                      <button onClick={() => navigate(`/configuracoes/pagamentos/edit/${id}`)}>
                        {i18n.t(`general.edit`)}
                        <i className='fa fa-cog'></i>
                      </button>
                    </div>
                    {configValues
                      .filter((item) => item.name && item.value)
                      .map((item) => (
                        <div key={item.name} className={styles.configValues}>
                          <p>{item.name}:</p>
                          <p style={{ color: '#6E7586' }}>
                            {verifySecurity(item.originalName)
                              ? hideCornerCharacters(item.value, verifySecurity(item.originalName))
                              : item.value}
                          </p>
                        </div>
                      ))}
                  </div>
                  {plans.map((plan) => (
                    <div key={plan.id} className={styles.configItem}>
                      <div className={styles.configHead}>
                        <div className={styles.configHeadTitle}>
                          <h2>
                            {findType(plan.type)} {plan.brand}
                          </h2>

                          {plan.brandItem && plan.brandItem.img && (
                            <img src={plan.brandItem.img} alt={plan.brand} />
                          )}
                        </div>
                        <button
                          onClick={() => {
                            changePaymentPlan(plan)
                            setAction('edit')
                            setEditId(plan.id)
                            showWrapperModal(i18n.t(`payment.edit_payment`))
                          }}
                        >
                          {i18n.t(`general.edit`)}
                          <i className='fa fa-cog'></i>
                        </button>
                      </div>
                      {hasIntegration && (
                        <p>
                          {i18n.t(`payment.code_erp`)}: {plan.code}
                        </p>
                      )}
                      {plan.installments && plan.installments.length > 1 && (
                        <div className={styles.tableInstallment}>
                          <div className={styles.installmentHead}>
                            <p>{i18n.t(`payment.installments`)}</p>
                            {hasIntegration && <p>{i18n.t(`payment.code_erp`)}</p>}
                          </div>
                          {plan.installments.map((installmentItem) => (
                            <div key={installmentItem.code} className={styles.installmentItem}>
                              <p>{installmentItem.installment}x</p>
                              {hasIntegration && <p>{installmentItem.code}</p>}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                  <div className={styles.configAdd}>
                    <button
                      onClick={() => {
                        clearFields()
                        setAction('create')
                        showWrapperModal(i18n.t(`payment.add_payment`))
                      }}
                    >
                      {i18n.t(`payment.add_payment`)}
                      <i className='fa fa-plus-circle'></i>
                    </button>
                  </div>
                </div>
              )}
              <div className='d-flex w-100 justify-content-between align-items-center p-9'>
                <Button
                  text={i18n.t(`buttons.back`)}
                  color='info'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {
                    navigate('/configuracoes/pagamentos')
                  }}
                  btnClass='fw-bolder'
                />
                <div className={styles.deleteConfig} onClick={deletePaymentConfig}>
                  <p>{i18n.t(`payment.delete_payment`)}?</p>
                </div>
              </div>
            </div>
            <ModalWrapper
              noCloseButton
              confirmButtomColor='primary'
              textAction={i18n.t(`buttons.save`)}
              confirmAction={
                action === 'create'
                  ? async () => await createPaymentMethod()
                  : async () => await editPaymentMethod()
              }
              maxWidth={true}
              width={50}
            >
              <div className='d-flex flex-column mt-5 py-5'>
                {action === 'create' && (
                  <div className={styles.modalMethod}>
                    <p>{i18n.t(`payment.method`)}</p>
                    <div className='d-flex flex-row'>
                      <Input
                        inputAttr={{
                          type: 'radio',
                        }}
                        name='cardType'
                        id='credit'
                        label={i18n.t(`payment.card`)}
                        checked={typeCard === 'credit'}
                        value={'Credit'}
                        change={(value: boolean) => {
                          if (value) setTypeCard('credit')
                        }}
                        icon={
                          <i
                            style={{ marginLeft: 5, color: '#3C9EE5' }}
                            className='fa fa-credit-card'
                          ></i>
                        }
                      />
                    </div>
                    {payment && payment.parameters.includes('ableDebit') && (
                      <div className='d-flex flex-row'>
                        <Input
                          inputAttr={{
                            type: 'radio',
                          }}
                          name='cardType'
                          id='debit'
                          label={i18n.t(`payment.debit`)}
                          checked={typeCard === 'debit'}
                          value={'debit'}
                          change={(value: boolean) => {
                            if (value) setTypeCard('debit')
                          }}
                          icon={
                            <i
                              style={{ marginLeft: 5, color: '#3C9EE5' }}
                              className='fa fa-credit-card'
                            ></i>
                          }
                        />
                      </div>
                    )}
                    {payment &&
                      (payment.parameters.includes('pix') ||
                        payment.parameters.includes('ablePix')) && (
                        <div className='d-flex flex-row'>
                          <Input
                            inputAttr={{
                              type: 'radio',
                            }}
                            name='cardType'
                            id='debit'
                            label='Pix'
                            checked={typeCard === 'pix'}
                            value={'pix'}
                            change={(value: boolean) => {
                              if (value) setTypeCard('pix')
                            }}
                            icon={
                              <svg
                                style={{ marginLeft: 5 }}
                                width='20'
                                height='20'
                                viewBox='0 0 20 20'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M20.0036 9.98999C19.9836 9.14999 19.7039 8.42999 19.1045 7.82999C18.4052 7.10999 17.6859 6.40999 16.9866 5.68999C16.8867 5.58999 16.8068 5.52999 16.647 5.54999C16.3073 5.56999 15.9676 5.54999 15.628 5.54999C15.0486 5.54999 14.569 5.74999 14.1495 6.16999C13.1704 7.14999 12.1914 8.12999 11.2124 9.10999C10.573 9.74999 9.7139 9.72999 9.07454 9.10999C8.9147 8.94999 8.75486 8.78999 8.59501 8.62999C7.77583 7.80999 6.95665 6.98999 6.13747 6.16999C5.75785 5.78999 5.29831 5.56999 4.73887 5.54999C4.31929 5.54999 3.89971 5.54999 3.48013 5.54999C3.44017 5.54999 3.38023 5.54999 3.34027 5.54999C3.26035 5.52999 3.20041 5.54999 3.14047 5.60999C2.40121 6.34999 1.64197 7.10999 0.902706 7.84999C0.363245 8.38999 0.063545 9.04999 0.0435649 9.80999C0.0036049 10.71 0.303305 11.49 0.942666 12.13C1.64197 12.83 2.34127 13.53 3.02059 14.23C3.14047 14.35 3.26035 14.43 3.46015 14.41C3.83977 14.37 4.23937 14.39 4.61899 14.41C5.23837 14.41 5.75785 14.19 6.17743 13.77C7.15645 12.79 8.13547 11.79 9.13448 10.81C9.43418 10.51 9.8138 10.37 10.2334 10.39C10.633 10.41 10.9726 10.59 11.2723 10.89C12.2314 11.87 13.2104 12.85 14.1894 13.81C14.4891 14.11 14.8288 14.29 15.2484 14.35C15.5281 14.39 15.8278 14.39 16.1075 14.39C16.3073 14.39 16.5271 14.37 16.7269 14.39C16.8268 14.41 16.8867 14.37 16.9467 14.31C17.6859 13.57 18.4052 12.85 19.1445 12.11C19.6839 11.55 19.9836 10.83 20.0036 9.98999ZM15.9277 4.68999C15.9477 4.66999 15.9477 4.66999 15.9676 4.64999C15.9277 4.62999 15.8877 4.60999 15.8478 4.58999C14.629 3.36999 13.4102 2.14999 12.1914 0.929991C11.4921 0.229991 10.653 -0.0900094 9.67394 0.00999064C8.97464 0.0699906 8.37523 0.349991 7.87573 0.849991C6.63697 2.08999 5.39821 3.32999 4.15945 4.56999C4.13947 4.58999 4.11949 4.62999 4.07953 4.66999C4.27933 4.66999 4.47913 4.66999 4.65895 4.66999C5.45815 4.66999 6.13747 4.94999 6.71689 5.52999C7.71589 6.52999 8.69491 7.50999 9.69392 8.50999C9.97364 8.78999 10.2933 8.78999 10.573 8.50999C11.5521 7.52999 12.5311 6.54999 13.5101 5.56999C14.0895 4.98999 14.7888 4.68999 15.608 4.68999C15.7079 4.68999 15.8078 4.68999 15.9277 4.68999ZM4.07953 15.31C4.05955 15.33 4.05955 15.33 4.03957 15.35C4.07953 15.37 4.11949 15.39 4.15945 15.41C5.37823 16.61 6.57703 17.83 7.79581 19.05C8.49512 19.75 9.33428 20.07 10.3133 19.97C11.0126 19.91 11.612 19.63 12.0915 19.13C13.3503 17.87 14.609 16.63 15.8478 15.37C15.8677 15.35 15.8877 15.33 15.9277 15.29C15.8478 15.29 15.8078 15.29 15.7479 15.29C15.588 15.29 15.4082 15.29 15.2484 15.27C14.5491 15.19 13.9497 14.89 13.4502 14.37C12.4911 13.41 11.5121 12.45 10.573 11.47C10.3133 11.21 9.9137 11.21 9.65396 11.47C8.69491 12.43 7.73587 13.39 6.77683 14.37C6.15745 14.99 5.41819 15.31 4.53907 15.29C4.37923 15.31 4.23937 15.31 4.07953 15.31Z'
                                  fill='black'
                                />
                                <path
                                  d='M20.0035 9.99C19.9835 10.81 19.7038 11.53 19.1244 12.13C18.3851 12.87 17.6659 13.59 16.9266 14.33C16.8667 14.39 16.8067 14.43 16.7068 14.41C16.507 14.39 16.2872 14.41 16.0874 14.41C15.8077 14.41 15.508 14.41 15.2283 14.37C14.8087 14.31 14.4691 14.11 14.1694 13.83C13.1903 12.85 12.2113 11.89 11.2523 10.91C10.9526 10.59 10.6129 10.41 10.1933 10.39C9.77376 10.37 9.39413 10.51 9.09443 10.81C8.11541 11.79 7.11641 12.77 6.13739 13.77C5.69783 14.21 5.19833 14.43 4.57895 14.41C4.19933 14.41 3.79973 14.39 3.42011 14.41C3.22031 14.43 3.10043 14.35 2.98055 14.23C2.28125 13.53 1.58195 12.83 0.902627 12.13C0.263266 11.51 -0.0364342 10.73 0.00352589 9.83C0.0434859 9.07 0.323206 8.41 0.862667 7.87C1.60193 7.13 2.36117 6.37 3.10043 5.63C3.16037 5.57 3.20033 5.55 3.30023 5.57C3.34019 5.59 3.40013 5.57 3.44009 5.57C3.85967 5.57 4.27925 5.57 4.69883 5.57C5.23829 5.59 5.71781 5.79 6.09743 6.19C6.91661 7.01 7.73579 7.83 8.55497 8.65C8.71481 8.81 8.87465 8.97 9.03449 9.13C9.67386 9.77 10.533 9.77 11.1724 9.13C12.1514 8.15 13.1304 7.17 14.1094 6.19C14.509 5.79 15.0085 5.59 15.5879 5.57C15.9276 5.57 16.2673 5.59 16.6069 5.57C16.7668 5.55 16.8467 5.61 16.9466 5.71C17.6459 6.43 18.3652 7.13 19.0645 7.85C19.6838 8.43 19.9835 9.17 20.0035 9.99Z'
                                  fill='#2CB4A9'
                                />
                                <path
                                  d='M15.9277 4.68999C15.8278 4.68999 15.708 4.68999 15.6081 4.68999C14.7889 4.68999 14.0896 4.98999 13.5102 5.56999C12.5311 6.54999 11.5521 7.52999 10.5731 8.50999C10.2934 8.78999 9.9737 8.78999 9.69398 8.50999C8.69497 7.50999 7.71595 6.52999 6.71695 5.52999C6.15751 4.96999 5.45821 4.68999 4.65901 4.66999C4.47919 4.66999 4.27939 4.66999 4.07959 4.66999C4.11955 4.62999 4.13953 4.58999 4.15951 4.56999C5.39827 3.32999 6.63703 2.08999 7.87579 0.849991C8.37529 0.349991 8.9747 0.0899906 9.674 0.00999064C10.653 -0.0900094 11.4922 0.229991 12.1915 0.929991C13.4103 2.14999 14.629 3.36999 15.8278 4.56999C15.8678 4.60999 15.9078 4.60999 15.9477 4.62999C15.9477 4.64999 15.9277 4.66999 15.9277 4.68999Z'
                                  fill='#2CB4A9'
                                />
                                <path
                                  d='M4.07951 15.31C4.23935 15.31 4.37921 15.31 4.53905 15.31C5.41817 15.33 6.15743 15.01 6.77681 14.39C7.73585 13.43 8.69489 12.47 9.65394 11.49C9.91368 11.23 10.3133 11.23 10.573 11.49C11.5321 12.47 12.4911 13.43 13.4501 14.39C13.9496 14.89 14.549 15.19 15.2483 15.29C15.4082 15.31 15.588 15.29 15.7478 15.31C15.8078 15.31 15.8477 15.31 15.9277 15.31C15.8877 15.35 15.8677 15.37 15.8477 15.39C14.589 16.65 13.3502 17.91 12.0915 19.15C11.592 19.63 10.9926 19.91 10.3133 19.99C9.33426 20.09 8.49509 19.77 7.79579 19.07C6.59699 17.85 5.37821 16.65 4.15943 15.43C4.11947 15.39 4.07951 15.39 4.03955 15.37C4.05953 15.33 4.07951 15.33 4.07951 15.31Z'
                                  fill='#2CB4A9'
                                />
                              </svg>
                            }
                          />
                        </div>
                      )}
                    {payment && payment.id === 44 && (
                      <div className='d-flex flex-row'>
                        <Input
                          inputAttr={{
                            type: 'radio',
                          }}
                          name='cardType'
                          id='money'
                          label={i18n.t(`payment.money`)}
                          checked={typeCard === 'money'}
                          value={'money'}
                          change={(value: boolean) => {
                            if (value) setTypeCard('money')
                          }}
                          icon={
                            <svg
                              style={{ marginLeft: 5 }}
                              width='16'
                              height='14'
                              viewBox='0 0 16 14'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M7.24609 10.9062C7.38281 10.8789 7.49219 10.8516 7.62891 10.8242C9.16016 10.4414 10.8828 9.97656 12.6875 10.0312C12.7969 9.18359 13.5352 8.52734 14.4375 8.52734V3.6875C13.4531 3.6875 12.6875 2.92188 12.6875 1.96484C11.4023 1.91016 10.0352 2.21094 8.47656 2.62109C8.33984 2.64844 8.23047 2.67578 8.09375 2.70312C6.5625 3.08594 4.83984 3.55078 3.03516 3.49609C2.92578 4.34375 2.1875 5 1.3125 5V9.8125C2.26953 9.8125 3.03516 10.6055 3.0625 11.5625C4.34766 11.6172 5.6875 11.3164 7.24609 10.9062ZM0 11.2891V2.83984C0 2.18359 0.683594 1.74609 1.3125 1.91016C3.5 2.51172 5.6875 1.96484 7.875 1.41797C10.2266 0.816406 12.6055 0.1875 14.9844 1.08984C15.4492 1.25391 15.75 1.71875 15.75 2.23828V10.6602C15.75 11.3438 15.0391 11.7812 14.4102 11.5898C12.2227 10.9883 10.0352 11.5625 7.875 12.1094C5.49609 12.7109 3.11719 13.3125 0.738281 12.4375C0.273438 12.2734 0 11.7812 0 11.2891ZM7.875 9.375C6.64453 9.375 5.6875 8.19922 5.6875 6.75C5.6875 5.30078 6.64453 4.125 7.875 4.125C9.07812 4.125 10.0625 5.30078 10.0625 6.75C10.0625 8.19922 9.07812 9.375 7.875 9.375Z'
                                fill='#E19C15'
                              />
                            </svg>
                          }
                        />
                      </div>
                    )}
                    {payment && payment.parameters.includes('ableOthers') && payment.id === 44 && (
                      <div className='d-flex flex-row'>
                        <Input
                          inputAttr={{
                            type: 'radio',
                          }}
                          name='cardType'
                          id='others'
                          label={i18n.t(`payment.others`)}
                          checked={typeCard === 'others'}
                          value={'others'}
                          change={(value: boolean) => {
                            if (value) setTypeCard('others')
                          }}
                          icon={
                            <svg
                              style={{ marginLeft: 5 }}
                              width='16'
                              height='16'
                              viewBox='0 0 50 50'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M49.4863 20.9105C49.4863 19.0549 48.4396 17.4267 46.9118 16.5915C47.0757 16.1104 47.1708 15.6029 47.1708 15.0743C47.1708 13.832 46.6898 12.6689 45.8175 11.7967L35.3768 1.35597C33.5688 -0.45199 30.6296 -0.45199 28.8216 1.35597L21.0241 9.15346C11.5297 9.22218 2.51634 10.2425 0.481065 18.0241C0.142734 18.8329 0 19.832 0 20.9052V44.599C0 47.3004 2.20973 49.5101 4.91109 49.5101H44.5752C47.2766 49.5101 49.4863 47.3004 49.4863 44.599V37.6632H31.1582C28.4569 37.6632 26.2471 35.4535 26.2471 32.7521C26.2471 30.0507 28.4569 27.841 31.1582 27.841H49.4863V20.9052V20.9105ZM17.8258 12.3465L14.1782 15.9941H5.00096C7.09439 13.7421 11.1174 12.6478 17.8258 12.3465ZM18.6347 15.9941L31.0419 3.58685C31.6181 3.01062 32.5644 3.00534 33.1406 3.58685L43.5813 14.0275C43.8615 14.3077 44.0148 14.6778 44.0148 15.0743C44.0148 15.4179 43.8985 15.7351 43.6924 15.9941H18.64H18.6347Z'
                                fill='#1B1B1B'
                              />
                              <path
                                d='M27.7803 32.8365C27.7803 34.8348 29.4032 36.4578 31.4015 36.4578C33.3998 36.4578 35.0227 34.8348 35.0227 32.8365C35.0227 30.8383 33.3998 29.2153 31.4015 29.2153C29.4032 29.2153 27.7803 30.8383 27.7803 32.8365Z'
                                fill='#1B1B1B'
                              />
                            </svg>
                          }
                        />
                      </div>
                    )}
                  </div>
                )}
                {action === 'edit' && (
                  <div className={styles.modalEditPayment}>
                    <div className={styles.modalEditPaymentTitle}>
                      <h2>
                        {findType(typeCard.charAt(0).toUpperCase() + typeCard.slice(1))} {brandName}
                      </h2>

                      {brandImg && brandImg !== '' && <img src={brandImg} alt={brandName} />}
                    </div>
                  </div>
                )}
                {typeCard === 'others' && (
                  <div className='d-flex flex-column gap-4'>
                    <div className={styles.modalPaymentSelect}>
                      <div className='w-100'>
                        <Input
                          inputAttr={{
                            type: 'default',
                          }}
                          placeholder='Nome do Meio de Pagamento'
                          label={'Nome do Meio de Pagamento'}
                          value={brandNameOthers}
                          change={(value: string) => setBrandNameOthers(value)}
                        />
                      </div>
                      {hasIntegration && (
                        <div className='w-100'>
                          <Input
                            inputAttr={{
                              type: 'text',
                            }}
                            placeholder='-'
                            label={i18n.t(`payment.code_erp`)}
                            value={codeErpIntegration}
                            change={(value: string) => setCodeErpIntegration(value)}
                          />
                        </div>
                      )}
                    </div>
                    <div className={styles.modalPaymentSelect}>
                      <div className='w-100'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          placeholder='Selecione'
                          label={i18n.t(`payment.max_installments`)}
                          options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((number) => ({
                            select: number,
                            value: number,
                          }))}
                          value={installments}
                          change={(value: string) => selectInstallments(parseInt(value))}
                        />
                      </div>
                    </div>
                    <div className={styles.modalPaymentSelect}>
                      <div className='w-100'>
                        <Input
                          inputAttr={{
                            type: 'money',
                          }}
                          currency='BRL'
                          locale='pt-BR'
                          label={i18n.t(`payment.min_value_installments`)}
                          value={minimumValue}
                          change={(value: number) => {
                            setMinimumValue(value)
                          }}
                        />
                      </div>
                    </div>
                    {hasIntegration &&
                      listInstallments.map((installmentItem) => (
                        <div className={styles.modalInstallment} key={installmentItem.installment}>
                          <p>
                            Parcelas:{' '}
                            {installmentItem.installment > 9
                              ? installmentItem.installment
                              : `0${installmentItem.installment}`}
                          </p>
                          <Input
                            inputAttr={{
                              type: 'number',
                            }}
                            placeholder='-'
                            label={i18n.t(`payment.code_erp`)}
                            value={installmentItem.code}
                            change={(value: string) => {
                              setListInstallments(
                                listInstallments.map((installmentChange) => {
                                  if (installmentChange.installment === installmentItem.installment) {
                                    installmentChange.code = parseInt(value)
                                  }
                                  return installmentChange
                                })
                              )
                            }}
                          />
                        </div>
                      ))}
                  </div>
                )}
                <div className={styles.modalPaymentSelect}>
                  {(typeCard === 'credit' || typeCard === 'debit') && action === 'create' && (
                    <div className='w-100'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        placeholder='Selecione'
                        label={i18n.t(`payment_plans.card_flag`)}
                        options={brands.filter((brand: SelectType) => brand.value < 99)}
                        value={brandId}
                        change={(value: string) => {
                          setBrandId(parseInt(value))
                          const brand = brands.find((brd) => brd.value === parseInt(value))
                          setBrandName(brand ? brand.select : '')
                        }}
                      />
                    </div>
                  )}
                  {hasIntegration && typeCard !== 'others' && (
                    <div className='w-100'>
                      <Input
                        inputAttr={{
                          type: 'text',
                        }}
                        placeholder='-'
                        label={i18n.t(`payment.code_erp`)}
                        value={codeErpIntegration}
                        change={(value: string) => setCodeErpIntegration(value)}
                      />
                    </div>
                  )}
                </div>
                {typeCard === 'credit' && (
                  <div className='d-flex flex-column gap-4'>
                    <div className={styles.modalPaymentSelect}>
                      <div className='w-100'>
                        <Input
                          inputAttr={{
                            type: 'money',
                          }}
                          currency='BRL'
                          locale='pt-BR'
                          label={i18n.t(`payment.min_value_installments`)}
                          value={minimumValue}
                          change={(value: number) => {
                            setMinimumValue(value)
                          }}
                        />
                      </div>
                    </div>
                    <div className={styles.modalPaymentSelect}>
                      <div className='w-100'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          placeholder='Selecione'
                          label={i18n.t(`payment.max_installments`)}
                          options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((number) => ({
                            select: number,
                            value: number,
                          }))}
                          value={installments}
                          change={(value: string) => selectInstallments(parseInt(value))}
                        />
                      </div>
                    </div>
                    {hasIntegration &&
                      listInstallments.map((installmentItem) => (
                        <div className={styles.modalInstallment} key={installmentItem.installment}>
                          <p>
                            Parcelas:{' '}
                            {installmentItem.installment > 9
                              ? installmentItem.installment
                              : `0${installmentItem.installment}`}
                          </p>
                          <Input
                            inputAttr={{
                              type: 'number',
                            }}
                            placeholder='-'
                            label={i18n.t(`payment.code_erp`)}
                            value={installmentItem.code}
                            change={(value: string) => {
                              setListInstallments(
                                listInstallments.map((installmentChange) => {
                                  if (installmentChange.installment === installmentItem.installment) {
                                    installmentChange.code = parseInt(value)
                                  }
                                  return installmentChange
                                })
                              )
                            }}
                          />
                        </div>
                      ))}
                  </div>
                )}
                {id === '44' && hasMotorDiscount && (
                  <div>
                    <div className='w-100'>
                      {/* Campo para saber se habilita ou não o desconto */}
                      <Input
                        inputAttr={{
                          type: 'checkbox',
                        }}
                        label={i18n.t(`payment.able_discount`)}
                        value={discountAble}
                        checked={discountAble}
                        change={(value: boolean) => {
                          setDiscountAble(value)
                        }}
                      />
                    </div>
                    {/*Area para definir se desconto é monetario ou percentagem e seu valor */}
                    {discountAble && (
                      <div className='row '>
                        <div className='col-12 d-flex gap-5 align-items-center  '>
                          <div className='col-4'>
                            <Input
                              inputAttr={{ type: 'newRadioModal' }}
                              label={i18n.t(`payment.discount_percentage`)}
                              value={'percentage'}
                              checked={discountType === 'percentage'}
                              change={() => {
                                setDiscountType('percentage')
                                setDiscountValue(0)
                              }}
                              name='typeDiscount'
                              paddingLeft={'0px !important'}
                            />
                            <Input
                              inputAttr={{ type: 'newRadioModal' }}
                              label={i18n.t(`payment.discount_monetary`)}
                              value={'monetary'}
                              checked={discountType === 'monetary'}
                              change={() => {
                                setDiscountType('monetary')
                                setDiscountValue(0)
                              }}
                              name='typeDiscount'
                              paddingLeft={'0px !important'}
                            />
                          </div>

                          <Input
                            inputAttr={{
                              type: discountType === 'percentage' ? 'number' : 'money',
                            }}
                            currency='BRL'
                            locale='pt-BR'
                            value={
                              // eslint-disable-next-line eqeqeq
                              discountValue && parseFloat(discountValue.toString()) != 0
                                ? discountValue
                                : ``
                            }
                            placeholder={`0`}
                            change={(value: string) => setDiscountValue(parseFloat(value))}
                            label={i18n.t(`payment.discount_value`)}
                            minNumber={0}
                            maxNumber={100}
                            grow
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              {action === 'edit' && (
                <button
                  type='button'
                  className={`btn btn-outline-primary border border-primary me-3 w-100 ${styles.modalDelete}`}
                  onClick={() => {
                    closeWrapperModal()
                    showDeleteModal(i18n.t(`payment.confirm`))
                  }}
                >
                  {i18n.t(`payment.delete`)}
                </button>
              )}
            </ModalWrapper>
            <ModalDelete
              onClose={() => showWrapperModal(i18n.t(`payment.edit_payment`))}
              icon={
                <svg
                  width='204'
                  height='197'
                  viewBox='0 0 204 197'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <g clip-path='url(#clip0_3074_4190)'>
                    <path
                      d='M159.301 0.285833L9.67877 32.3073C3.18191 33.6978 -0.957669 40.0917 0.432766 46.5886L30.4222 186.715C31.8126 193.212 38.2065 197.352 44.7034 195.961L194.325 163.94C200.822 162.549 204.962 156.156 203.571 149.659L173.582 9.53184C172.191 3.03498 165.797 -1.1046 159.301 0.285833Z'
                      fill='#E8EDFC'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M165.34 146.75C167 147.19 168.48 149.15 168.65 151.13C168.82 153.11 167.62 154.36 165.96 153.92C164.3 153.48 162.82 151.52 162.65 149.54C162.48 147.56 163.68 146.31 165.34 146.75Z'
                      fill='#BDD0FB'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M138.12 144.13C140.97 144.88 143.52 148.26 143.82 151.67C144.12 155.08 142.04 157.23 139.19 156.48C136.34 155.73 133.79 152.35 133.49 148.94C133.19 145.53 135.27 143.38 138.12 144.13Z'
                      fill='#BDD0FB'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M166.67 173.59C167.77 173.88 168.75 175.18 168.86 176.49C168.97 177.8 168.18 178.62 167.08 178.34C165.99 178.05 165.01 176.75 164.89 175.44C164.78 174.13 165.57 173.3 166.67 173.59Z'
                      fill='#BDD0FB'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M196.92 139.82C198.02 140.11 199 141.41 199.11 142.72C199.22 144.03 198.43 144.86 197.33 144.57C196.24 144.28 195.26 142.98 195.14 141.68C195.03 140.37 195.82 139.54 196.92 139.83V139.82Z'
                      fill='#BDD0FB'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M155.85 119.09C156.95 119.38 157.93 120.68 158.04 121.99C158.15 123.3 157.36 124.13 156.26 123.84C155.16 123.55 154.18 122.25 154.07 120.94C153.96 119.63 154.75 118.8 155.85 119.09Z'
                      fill='#BDD0FB'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M118.11 146.98C119.21 147.27 120.18 148.57 120.3 149.88C120.42 151.19 119.62 152.02 118.52 151.73C117.42 151.44 116.44 150.14 116.33 148.83C116.22 147.52 117.01 146.69 118.11 146.98Z'
                      fill='#BDD0FB'
                    />
                    <path
                      d='M91.51 42.4899H69.14C67.6 42.4899 66.36 41.2399 66.36 39.7099C66.36 38.1699 67.61 36.9299 69.14 36.9299H91.51C93.05 36.9299 94.29 38.1799 94.29 39.7099C94.29 41.2499 93.04 42.4899 91.51 42.4899Z'
                      fill='#BDD0FB'
                    />
                    <path
                      d='M75.03 31.58H3.12998C1.58998 31.58 0.349976 30.33 0.349976 28.8C0.349976 27.26 1.59998 26.02 3.12998 26.02H75.04C76.58 26.02 77.82 27.27 77.82 28.8C77.82 30.34 76.57 31.58 75.04 31.58H75.03Z'
                      fill='#BDD0FB'
                    />
                    <path
                      d='M59.06 42.4799H11.77C10.23 42.4799 8.98999 41.2299 8.98999 39.6999C8.98999 38.1599 10.24 36.9199 11.77 36.9199H59.06C60.6 36.9199 61.84 38.1699 61.84 39.6999C61.84 41.2399 60.59 42.4799 59.06 42.4799Z'
                      fill='#BDD0FB'
                    />
                    <path
                      d='M63.23 64.27H11.77C10.23 64.27 8.98999 63.02 8.98999 61.49C8.98999 59.95 10.24 58.71 11.77 58.71H63.23C64.77 58.71 66.01 59.96 66.01 61.49C66.01 63.03 64.76 64.27 63.23 64.27Z'
                      fill='#BDD0FB'
                    />
                    <path
                      d='M91.7399 53.3701H19.8299C18.2899 53.3701 17.0499 52.1201 17.0499 50.5901C17.0499 49.0501 18.2999 47.8101 19.8299 47.8101H91.7399C93.2799 47.8101 94.5199 49.0601 94.5199 50.5901C94.5199 52.1301 93.2699 53.3701 91.7399 53.3701Z'
                      fill='#BDD0FB'
                    />
                    <path
                      d='M70.71 138.03H70.63C63.51 137.79 57.92 132.02 57.92 124.89C57.92 122.77 58.44 120.65 59.44 118.77C59.44 118.77 59.5 118.65 59.52 118.63L90.97 64.1499C90.97 64.1499 91.02 64.0699 91.05 64.0199L91.16 63.8699C93.62 60.3099 97.67 58.1899 101.99 58.1899C106.31 58.1899 110.36 60.3099 112.82 63.8699L112.93 64.0199C112.93 64.0199 112.98 64.0999 113.01 64.1399L144.63 118.91C144.63 118.91 144.68 118.99 144.7 119.03L144.77 119.18C145.64 120.97 146.08 122.9 146.08 124.89C146.08 132.02 140.49 137.79 133.36 138.03H70.71Z'
                      fill='#EAB83B'
                    />
                    <path
                      d='M139.04 121.95L138.51 121.03L108.13 68.41L107.6 67.5C106.37 65.72 104.32 64.55 102 64.55C99.68 64.55 97.62 65.72 96.39 67.5L95.86 68.41L65.27 121.41L65.07 121.75C64.57 122.69 64.29 123.76 64.29 124.91C64.29 128.58 67.21 131.56 70.85 131.69H133.15C136.79 131.57 139.71 128.59 139.71 124.91C139.71 123.85 139.46 122.85 139.03 121.96L139.04 121.95Z'
                      fill='white'
                    />
                    <path
                      d='M101.99 108.56C98.97 108.56 96.52 106.11 96.52 103.09V87.0598C96.52 84.0398 98.96 81.5898 101.99 81.5898C105.02 81.5898 107.45 84.0398 107.45 87.0598V103.09C107.45 106.11 105 108.56 101.99 108.56Z'
                      fill='#6E80FF'
                    />
                    <path
                      d='M107.43 115.85C107.43 112.84 105 110.4 101.99 110.4C98.98 110.4 96.54 112.84 96.54 115.85C96.54 118.86 98.98 121.29 101.99 121.29C105 121.29 107.43 118.85 107.43 115.85Z'
                      fill='#6E80FF'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_3074_4190'>
                      <rect
                        width='203.68'
                        height='196.23'
                        fill='white'
                        transform='translate(0.160034)'
                      />
                    </clipPath>
                  </defs>
                </svg>
              }
              title={`${i18n.t(`payment.delete_payment`)} ${findType(
                typeCard.charAt(0).toUpperCase() + typeCard.slice(1)
              )} ${brandName}?`}
              confirmAction={() => {
                closeWrapperModal()
                deletePayment()
              }}
            />
          </div>
        )}
    </>
  )
}

const PaymentConfig: FC = () => {
  const { id } = useParams()

  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: true },
          { title: i18n.t(`payment.methods`), path: 'configuracoes/pagamentos', isActive: true },
          {
            title: i18n.t(`payment.gateway`),
            path: `configuracoes/pagamentos/${id}`,
            isActive: true,
          },
        ]}
      >
        {i18n.t(`payment.gateway`)}
      </PageTitle>
      <PaymentConfigContent />
    </>
  )
}

export { PaymentConfig }
